var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { gameController } from "../../game_theme/flow_fb/flowController";
import { _version } from "../../game_theme/version/version";
import { ComponentButton } from "../framework/components/ComponentButton";
import { ComponentContainer } from "../framework/components/ComponentContainer";
import { ComponentLabel } from "../framework/components/ComponentLabel";
import { ComponentPicture } from "../framework/components/ComponentPicture";
import { DialogBase } from "../framework/dialogs/DialogBase";
import { tbKeyCodes } from "../framework/tbKeyCodes";
import { tgfAudio } from "../framework/tgfAudio";
import { tgfDictionary } from "../framework/tgfDictionary";
import { tgfGraphics } from "../framework/tgfGraphics";
import { tgfSettings } from "../framework/tgfSettings";
import { tgfStatus } from "../framework/tgfStatus";
import { DialogSettings, MiscSettings } from "../settings/Settings";
import { SoundManager } from "../settings/SoundManager";
import { AngryAnalytics } from "./Analytics/Analytics";
import { angrybirds_regular } from "./AssetDefinitions/FontDefinitions";
import { s_black_square, s_popup_top, s_popup_bottom, s_icon_close, s_popup_close, s_btn_orange, s_icon_music, s_icon_musicoff, s_icon_sound, s_icon_soundoff, s_popup_darkblue_rect } from "./AssetDefinitions/ImageDefinitions";
import { ExpManager } from "./ExpManager";
import { AngryTutorial } from "./LobbyCode/AngryTutorialDialog";
import { PlayerRightsDialog } from "./LobbyCode/PlayerRightsDialog";
import { playController } from "./gameController";
import { youtubeMuteManager } from "./YoutubeMuteManager";
var AngryOptionScreenDialog = /** @class */ (function (_super) {
    __extends(AngryOptionScreenDialog, _super);
    function AngryOptionScreenDialog(properties) {
        var _this = _super.call(this) || this;
        _this.topButtonPosition = 140;
        _this.buttonOffset = 120;
        _this.name = "TooltipDialog"; // The name of the dialog
        if (properties !== undefined) {
            _this.setProperties(properties);
        }
        return _this;
    }
    AngryOptionScreenDialog.prototype.doPrepare = function () {
        var _a = this._addBackground(), top = _a[0], bottom = _a[1];
        this.addComponent(this.firstContainer);
        this._addContentButtons();
        this._addCloseButton();
        this._addVersionNumber(bottom);
        this.tutorialDialog = new AngryTutorial({
            delayClose: false,
            x: tgfGraphics.areaWidth / 2,
            y: tgfGraphics.areaHeight / 2,
        });
    };
    AngryOptionScreenDialog.prototype._addContentButtons = function () {
        var currentY = -this.height / 2 + this.topButtonPosition;
        var currentX = 0;
        for (var i = 0; i < this.optionSettings.length; i++) {
            switch (this.optionSettings[i]) {
                case "tutorial":
                    this._addTutorialButton(currentX, currentY);
                    break;
                case "music":
                    this._addMusicButton(currentX, currentY);
                    break;
                case "sfx":
                    this._addSFXButton(currentX, currentY);
                    break;
                case "lobby":
                    this._addLobbyButton(currentX, currentY);
                    break;
                case "legal":
                    this._addLegalButton(currentX, currentY);
            }
            currentY += this.buttonOffset;
        }
    };
    AngryOptionScreenDialog.prototype._addLegalButton = function (currentX, currentY) {
        var _this = this;
        var legalButton = new ComponentButton({
            image: s_btn_orange,
            fontUp: DialogSettings.buttonFont,
            x: currentX,
            y: currentY,
            text: tgfDictionary.getText("BTN_PLAYER_RIGHTS"),
            onClick: function () {
                var playerRightsDialog = new PlayerRightsDialog({});
                playerRightsDialog.show();
                _this.disappear();
            }
        });
        this.firstContainer.addComponent(legalButton);
    };
    AngryOptionScreenDialog.prototype._addLobbyButton = function (currentX, currentY) {
        var _this = this;
        var lobbyButton = new ComponentButton({
            image: s_btn_orange,
            x: currentX, y: currentY,
            text: tgfDictionary.getText("BTN_RETURN_TO_LOBBY"),
            onClick: function () {
                playController.waitingForPlayerWithoutDialog = false;
                if (playController.isAI) {
                    AngryAnalytics.reportGameStatus(false, ExpManager.getRank());
                }
                gameController.stopPlay();
                if (_this.replayQueued === true) {
                    _this.onClose = null;
                }
                _this.disappear();
                SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            },
            fontDown: DialogSettings.buttonFont
        });
        this.firstContainer.addComponent(lobbyButton);
    };
    AngryOptionScreenDialog.prototype._addSFXButton = function (currentX, currentY) {
        var prefs = tgfStatus.getPreferencesData();
        var isEffectMuted = 1;
        if (!prefs.effectsMuted) {
            isEffectMuted = 0;
        }
        //this.container.addComponent(this.musicComponent);
        var soundEffectButton = new ComponentButton({
            image: s_btn_orange, x: currentX, y: currentY,
            icon: s_icon_sound, iconPosition: "right",
            toggleIndex: isEffectMuted,
            toggleAutomatic: true,
            text: tgfDictionary.getText("BTN_SOUND"),
            onClick: function () {
                soundEffectButton.toggleIndex = (soundEffectButton.toggleIndex + 1) % 2;
                switch (soundEffectButton.toggleIndex) {
                    case 0:
                        soundEffectButton.changeIcon(s_icon_sound);
                        if (!youtubeMuteManager.muted) {
                            tgfAudio.unmuteEffects();
                        }
                        tgfStatus.setAudio(false, undefined, undefined, undefined);
                        break;
                    case 1:
                        soundEffectButton.changeIcon(s_icon_soundoff);
                        tgfAudio.muteEffects();
                        tgfStatus.setAudio(true, undefined, undefined, undefined);
                        break;
                }
                SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            },
            fontDown: DialogSettings.buttonFont
        });
        soundEffectButton.changeIcon(isEffectMuted ? s_icon_soundoff : s_icon_sound);
        this.firstContainer.addComponent(soundEffectButton);
    };
    AngryOptionScreenDialog.prototype._addMusicButton = function (currentX, currentY) {
        var prefs = tgfStatus.getPreferencesData();
        var isMusicMuted = 1;
        if (!prefs.musicMuted) {
            isMusicMuted = 0;
        }
        var musicButton = new ComponentButton({
            image: s_btn_orange, x: currentX, y: currentY,
            icon: s_icon_music, iconPosition: "right",
            toggleIndex: isMusicMuted,
            toggleAutomatic: true,
            text: tgfDictionary.getText("BTN_MUSIC"),
            onClick: function (component) {
                musicButton.toggleIndex = (musicButton.toggleIndex + 1) % 2;
                switch (musicButton.toggleIndex) {
                    case 0:
                        musicButton.changeIcon(s_icon_music);
                        if (!youtubeMuteManager.muted) {
                            tgfAudio.unmuteMusic();
                        }
                        tgfStatus.setAudio(undefined, undefined, false, undefined);
                        break;
                    case 1:
                        musicButton.changeIcon(s_icon_musicoff);
                        tgfAudio.muteMusic();
                        tgfStatus.setAudio(undefined, undefined, true, undefined);
                        break;
                }
                SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            },
            fontDown: DialogSettings.buttonFont
        });
        musicButton.changeIcon(isMusicMuted ? s_icon_musicoff : s_icon_music);
        this.firstContainer.addComponent(musicButton);
    };
    AngryOptionScreenDialog.prototype._addTutorialButton = function (currentX, currentY) {
        var _this = this;
        var tutorialButton = new ComponentButton({
            image: s_btn_orange,
            x: currentX, y: currentY,
            text: tgfDictionary.getText("BTN_HOW_TO_PLAY"),
            onClick: function () {
                SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
                if (_this.onTutorial) {
                    _this.onTutorial(_this);
                }
                else {
                    _this.openTutorial();
                }
            },
            fontDown: DialogSettings.buttonFont
        });
        this.firstContainer.addComponent(tutorialButton);
    };
    AngryOptionScreenDialog.prototype._addBackground = function () {
        this.transparentBlack = new ComponentButton({
            x: tgfGraphics.areaWidth / 2,
            y: tgfGraphics.areaHeight / 2,
            xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
            yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
            alpha: 0.7,
            image: s_black_square
        });
        this.addComponent(this.transparentBlack);
        this.firstContainer = new ComponentContainer({ x: tgfGraphics.areaWidth / 2, y: tgfGraphics.areaHeight / 2 });
        var backgroundBox = new ComponentPicture({
            image: s_popup_darkblue_rect,
            x: -400, y: -325,
            sliceMarginsArray: [55, 55, 55, 55],
            width: this.width,
            height: this.height,
            createFromSlices: true
        });
        this.firstContainer.addComponent(backgroundBox);
        var top = new ComponentPicture({ image: s_popup_top, y: -this.height / 2 });
        this.firstContainer.addComponent(top);
        top.addComponent(new ComponentLabel({
            text: tgfDictionary.getText('SETTINGS_HEADER'), y: 4, font: {
                fontFace: angrybirds_regular.fontFace,
                fontSize: 36,
                fillColor: "#ffffff",
                align: "center",
                baseline: "middle"
            }
        }));
        var bottom = new ComponentPicture({ image: s_popup_bottom, y: this.height / 2 - 20 });
        this.firstContainer.addComponent(bottom);
        return [top, bottom];
    };
    AngryOptionScreenDialog.prototype._addCloseButton = function () {
        var _this = this;
        this.firstContainer.addComponent(new ComponentButton({
            image: s_popup_close,
            icon: s_icon_close,
            iconPosition: "center",
            x: this.width / 2 + 5,
            y: -this.height / 2 + 33,
            shortcutKey: tbKeyCodes.vkEscape,
            touchMargin: MiscSettings.closeButtonTouchMargin,
            onClick: function () {
                AngryAnalytics.reportUXButtonClose("settings");
                _this.disappear();
                SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
            }
        }));
    };
    AngryOptionScreenDialog.prototype._addVersionNumber = function (bottom) {
        var version = _version || 'dev';
        if (version) {
            if (tgfSettings.environment) {
                version += "-" + (tgfSettings.environment);
            }
            var ver = new ComponentLabel({
                text: "ver: " + version,
                font: { fontFace: angrybirds_regular.fontFace, fontSize: 22, fillColor: "#ffffff", baseline: "middle" },
                align: "center",
                x: 0, y: -30
            });
            bottom.addComponent(ver);
        }
    };
    AngryOptionScreenDialog.prototype.openTutorial = function () {
        var self = this;
        this.disappear();
        if (playController) {
            playController.tutorialDialog = this.tutorialDialog;
        }
        this.tutorialDialog.show();
    };
    ;
    AngryOptionScreenDialog.prototype.disappear = function () {
        this.deactivate();
        this.hide();
        if (this.onClose) {
            this.onClose();
        }
        if (playController) {
            playController.optionScreen = null;
            playController.tutorialDialog = null;
        }
        this.free();
        // this.container.startSubEffect(2);
    };
    return AngryOptionScreenDialog;
}(DialogBase));
export { AngryOptionScreenDialog };
